module.exports = __webpack_public_path__ + "static/media/login-bg.114cbd5e.webp";